<template>
    <div style="max-width: 100%;">
        <div class="d-flex flex-column mb-4" style="max-width: 100%;">
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="2" v-if="newEngrase">
                    <v-combobox clearable v-model="selectedEmb" hide-details="true" :items="embarcs" dense
                        label="Embarcación" outlined></v-combobox>
                </v-col>
                <v-col cols="1" style="display: flex" v-if="newEngrase">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                                :disabled="selectedEmb == null" @click="generaEngrase(selectedEmb)">
                                <v-icon dark>mdi-clipboard-file-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Generar Engrase</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab dark small color="red" v-bind="attrs" v-on="on"
                                @click="newEngrase = false; selectedEmb = null">
                                <v-icon dark>mdi-clipboard-remove-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Cancelar</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="1" v-else>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                                @click="newEngrase = true">
                                <v-icon dark>mdi-clipboard-plus-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Generar Engrase Nuevo</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="2"></v-col>
            </v-row>
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="8" style="max-width: 100vw; overflow: hidden;">
                    <v-data-table :headers="headers" :items="filteredItems" class="elevation-1">
                        <template v-slot:item.fechaEngrase="{ item }">
                            <span>
                                {{ item.fechaEngrase == "2000-01-01" ? '' : formatDate(item.fechaEngrase) }}
                            </span>
                        </template>
                        <template v-slot:item.fechaProximoEngrase="{ item }">
                            <span :style="getDateStyle(item.color)">
                                {{ item.fechaProximoEngrase == "2000-01-01" ? '' :
                    formatDate(item.fechaProximoEngrase) }}
                            </span>
                        </template>
                        <template v-slot:item.estadoEngrase="{ item }">
                            <div class="text-center">
                                {{ item.idEstadoEngrase === 3 ?'Pendiente de Generar':item.idEstadoEngrase === 1 ?'En Proceso de Registro':'Pendiente de firmar'}}
                            </div>
                        </template>
                        <template v-slot:item.action="{ item }">

                            <v-btn :color="item.idEstadoEngrase === 3 ? 'green' : 'orange'" small
                                class="ma-2 white--text"
                                @click="item.idEstadoEngrase === 3 ? generaEngrase(item.embarcacion) : generaEngraseTabla(item)">
                                <span>{{ item.idEstadoEngrase === 3 ? 'Generar Engrase' : 'Continuar Proceso' }}</span>
                            </v-btn>

                        </template>

                    </v-data-table>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

        </div>
        <v-dialog v-model="dialogForm" width=1300 max-height="80vh" @update:model-value="onDialogOpened" persistent>
            <v-card>
                <v-card-title class="headline">
                    <span>CHECK LIST DE ENGRASE: {{ data.embarcacion }}</span>
                    <v-spacer></v-spacer>
                    <v-menu v-model="fromDateMenu1" :close-on-content-click="false" offset-y
                        transition="scale-transition" max-width="300px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="formattedDesde" placeholder="Fecha Engrase" label="Fecha Engrase"
                                style="max-width:200px !important" prepend-icon="mdi-calendar" clearable dense
                                hide-details="true" outlined readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaDesde" locale="es" full-width hide-header
                            color="#05435B"></v-date-picker>
                    </v-menu>
                    <v-progress-linear v-model="skill" color="blue-grey" height="20" class="mt-3">
                        <template v-slot:default="{ value }">
                            <strong :style="{ fontSize: '15px', color: value > 50 ? 'aliceblue' : 'black' }">{{
                    Math.ceil(value) }}%</strong>
                        </template>
                    </v-progress-linear>
                </v-card-title>

                <v-card-text style="overflow-x: auto; overflow-y: auto; max-height: 60vh;">
                    <v-row v-if="paso == 1">
                        <v-data-table dense :headers="headersForm" :items="lubricationData" hide-default-footer
                            :items-per-page="-1" style="margin-top: 15px; width: 100%; "
                            class="elevation-1 custom-table">
                            <template v-slot:item="{ item, index }">
                                <!-- <tr :class="getRowClass(index)"> -->
                                <tr :class="item.rowColors">
                                    <td v-if="item.sistema" :rowspan="item.rowspanSistema">{{ item.sistema }}</td>
                                    <td v-if="item.equipo" :rowspan="item.rowspanEquipo">{{ item.equipo }}</td>
                                    <td style="text-align: left;"><v-treeview dense :items="item.data"></v-treeview>
                                    </td>
                                    <td>{{ item.numPuntos }}</td>
                                    <td v-if="item.totalPuntos != null" :rowspan="item.rowspanTotalPuntos">{{
                    item.totalPuntos
                }}
                                    </td>
                                    <td>
                                        <div class="switch-container">
                                            <v-switch v-model="item.conEngrase" inset hide-details dense flat
                                                style="margin: 0; padding: 0px"></v-switch>
                                        </div>
                                    </td>
                                    <td>
                                        <div style="display: flex;">
                                            <v-textarea rows="1" style="font-size: 12px; min-height: 35px"
                                                v-model="item.observaciones" dense hide-details outlined></v-textarea>
                                            <v-tooltip bottom v-if="item.prioritario">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" dark medium color="#05435B"
                                                        class="hover-icon" @click="adjuntarEvidencia(item)">
                                                        mdi-paperclip-plus
                                                    </v-icon>
                                                </template>
                                                <span>Adjuntar Evidencia</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-row>
                    <!-- Paso 2: Firma Responsable -->
                    <v-row v-if="paso === 2" class="d-flex justify-center">
                        <!-- Si hay una firma guardada, muestra la imagen -->
                        <div v-if="signatureData" class="d-flex justify-center">
                            <div>
                                <img :src="signatureData" alt="Firma"
                                    style="margin-top: 20px; border: 1px solid black; width: 500px; height: 300px;" />
                            </div>
                            <div
                                style="display: flex; align-items: center; flex-direction: column; justify-content: center; padding: 20px;">
                                <v-btn class="white--text" color="red" @click="limpiarImagenFirma">Borrar Firma</v-btn>
                            </div>
                        </div>

                        <!-- Si no hay firma, muestra el canvas para dibujar -->
                        <div v-else style="height: 400px; display: flex; align-items: center; flex-direction: row;">
                            <div v-if="showCanvas" ref="signatureContainer"
                                style="width: 500px; height: 300px; border: 1px solid black; position: relative;">
                                <canvas ref="canvas"></canvas>
                            </div>
                            <div
                                style="display: flex; align-items: center; flex-direction: column; justify-content: center; padding: 20px;">
                                <v-btn class="mb-2 white--text" color="primary" @click="saveSignature">Guardar
                                    Firma</v-btn>
                                <v-btn class="white--text" color="red" @click="clearSignature">Borrar Firma</v-btn>
                            </div>
                        </div>
                    </v-row>


                </v-card-text>

                <v-card-actions>
                    <span>Total Componentes: {{ lubricationData.length }}</span>
                    <v-spacer></v-spacer>
                    <v-stepper v-model="paso" non-linear>
                        <v-stepper-header>
                            <v-stepper-step step="1">
                                Registrar Engrase
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step step="2">
                                Firma Responsable
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step step="3">
                                Completar Engrase
                            </v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>
                    <v-spacer></v-spacer>
                    <v-btn class="ma-2 white--text" color="red darken-1" @click="closeForm()">Cancelar</v-btn>
                    <v-btn v-if="paso == 1" class="ma-2 white--text" color="green darken-1"
                        @click="guardar()">Guardar</v-btn>
                    <v-btn v-else class="ma-2 white--text" color="orange darken-1" @click="paso = 1">Atrás</v-btn>
                    <v-btn v-if="paso == 1" class="ma-2 white--text" color="primary darken-1"
                        @click="engraseRegistro()">Continuar</v-btn>
                    <v-btn v-else class="ma-2 white--text" color="primary darken-1"
                        @click="enviarEngraseRegistro()">Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAdjuntos" max-width="600px">
            <v-card>
                <v-card-title class="headline d-flex justify-space-between">
                    {{ titleAdjuntos }}
                </v-card-title>

                <v-card-text>
                    <!-- Input para subir archivos -->
                    <v-file-input label="Seleccionar archivos" v-model="nuevosAdjuntos" multiple
                        accept=".png,.jpg,.jpeg,.pdf,.doc,.docx" chips show-size dense hide-details outlined
                        @change="agregarAdjuntos"></v-file-input>

                    <!-- Lista de archivos adjuntos -->
                    <v-list dense v-if="adjuntos.length">
                        <v-list-item v-for="(archivo, index) in adjuntos" :key="index">
                            <v-list-item-avatar>
                                <v-icon v-if="esImagen(archivo)" color="blue">mdi-file-image</v-icon>
                                <v-icon v-else color="green">mdi-file</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title>{{ archivo.name }}</v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-btn icon color="red" @click="eliminarAdjunto(index)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>

                    <p v-else class="text-center text-grey">No hay archivos adjuntos</p>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn color="red darken-1" class="white--text" @click="dialogAdjuntos = false">Cancelar</v-btn>
                    <v-btn color="green darken-1" class="white--text" @click="guardarAdjuntos">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';
import SignaturePad from 'signature_pad';
export default {
    data() {
        return {
            expanded: [],
            singleExpand: false,
            selectedEmbarcaciones: [],
            embarcaciones: [
                "ANA LUCIA", "BAMAR I", "BAMAR II", "BAMAR IV", "BAMAR VIII", "CHATA PH1", "CHATA PH5",
                "CHAVELI II", "CHIRA I", "ISABELITA", "IVANA B", "JACKELIN", "JADRANKA B", "KIARA B", "LOMAS"
            ],
            headers: [
                { text: "Embarcación", value: "embarcacion", align: "center" },
                { text: "Fecha Último Engrase", value: "fechaEngrase", align: "center" },
                { text: "Fecha Siguiente Engrase", value: "fechaProximoEngrase", align: "center" },
                { text: "Estado", value: "estadoEngrase" },
                { text: "Acción", value: "action", align: "center", sortable: false },
            ],
            headersMobile: [

            ],
            items: [
                { embarcacion: 'BAMAR I', fechaEngrase: '2025-01-30', fechaProximoEngrase: '2025-02-06', estadoEngrase: 'Sin Iniciar', idEstadoEngrase: 3, color: 'red' },
                { embarcacion: 'ANA LUCIA', fechaEngrase: '2025-01-29', fechaProximoEngrase: '2025-02-05', estadoEngrase: 'Sin Iniciar', idEstadoEngrase: 3, color: 'black' },
                { embarcacion: 'CHAVELI II', fechaEngrase: '2025-01-28', fechaProximoEngrase: '2025-02-04', estadoEngrase: 'En proceso', idEstadoEngrase: 1, color: 'red' },
                { embarcacion: 'CHATA PH1', fechaEngrase: '2025-01-27', fechaProximoEngrase: '2025-02-05', estadoEngrase: 'Sin Iniciar', idEstadoEngrase: 3, color: 'red' },
                { embarcacion: 'CHATA PH5', fechaEngrase: '2025-02-13', fechaProximoEngrase: '2025-02-27', estadoEngrase: 'Sin Iniciar', idEstadoEngrase: 3, color: 'red' }
            ],
            dialogForm: false,
            inputValue: '',
            data: {
                id: null,
                embarcacion: '',
                idResponsable: this.idUsuario,
                responsable: this.responsable,
                idEstado: this.paso,
                estado: 'Genera Engrase',
                fechaEngrase: null,
                fechaReporte: null,
                firmaResponsable: null

            },
            headersForm: [
                { text: "SISTEMA", value: "sistema", sortable: false },
                { text: "EQUIPO", value: "equipo", sortable: false },
                { text: "COMPONENTE", value: "nombre", sortable: false },
                { text: "N° PUNTOS", value: "numPuntos", sortable: false },
                { text: "TOTAL PUNTOS", value: "totalPuntos", sortable: false },
                { text: "Estado de Engrase", value: "otros", sortable: false, align: "left" },
                { text: "OBSERVACIONES", value: "observaciones", sortable: false, width: '30%' }
            ],
            lubricationData: [],
            paso: 1,
            signaturePad: null,
            signatureData: null,
            showCanvas: true,
            skill: 0,
            fromDateMenu1: false,
            fechaDesde: new Date().toISOString().substr(0, 10), // Fecha de hoy en formato YYYY-MM-DD
            dialogAdjuntos: false, // Controla el v-dialog
            adjuntos: [], // Lista de archivos adjuntados
            nuevosAdjuntos: [], // Archivos temporales antes de agregarlos
            titleAdjuntos: '',
            embarcs: [],
            selectedEmb: null,
            newEngrase: false,
        };
    },
    computed: {
        filteredItems() {
            if (this.selectedEmbarcaciones.length === 0) return this.items;
            return this.lubricationData.length > 0 ? (count / this.lubricationData.length) * 100 : 0;
        },
        formattedDesde: {
            get() {
                if (!this.fechaDesde) return ""; // Si `fechaDesde` es null o vacío, devuelve ""

                try {
                    return new Date(`${this.fechaDesde}T00:00:00`).toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                    });
                } catch (error) {
                    console.error("Error al formatear la fecha:", error);
                    return "";
                }
            },
            set(value) {
                if (!value || typeof value !== "string") {
                    this.fechaDesde = ""; // Si `value` es null o no es un string válido, asigna vacío
                    return;
                }

                const parts = value.split("/");
                if (parts.length === 3) {
                    this.fechaDesde = `${parts[2]}-${parts[1]}-${parts[0]}`; // Convierte DD/MM/YYYY a YYYY-MM-DD
                } else {
                    console.error("Formato de fecha inválido:", value);
                    this.fechaDesde = ""; // Si no es una fecha válida, deja el campo vacío
                }
            }
        },
        responsable: {
            get() {
                return this.$store.getters.user?.nombres || "Usuario";
            },
            set(value) {
            }
        },
        idUsuario: {
            get() {
                return this.$store.getters.user?.idUser || 1;
            },
            set(value) {
            }
        },
    },
    created() {
        this.lubricationData = [...this.flattenedData()];
        this.loadDataInit();
    },
    mounted() {

    },
    watch: {
        lubricationData: {
            handler(newValue) {
                let count = newValue.filter(item => item.conEngrase).length;
                console.log(count); // Verifica si se actualiza en la consola
                this.skill = newValue.length > 0 ? (count / newValue.length) * 100 : 0; // Convertimos a porcentaje
            },
            deep: true
        }
    },
    methods: {
        async loadDataInit() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            try {
                const response = await apiService.get("/engrase/get-control-engrase");
                this.items = response.data.controles;

                const response2 = await apiService.get("/engrase/get-embarcacion-engrase");
                if (response2.data.embarcacionList.length > 0) {
                    this.embarcs = response2.data.embarcacionList;
                } else {
                    this.embarcs = [];
                }
            } catch (error) {
                this.embarcs = [];

            } finally {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
            }

        },
        getConditionColor(condition) {
            switch (condition) {
                case "Sin Iniciar": return "orange";
                case "En proceso": return "green";
                default: return "grey";
            }
        },
        flattenedData() {
            let rows = [];
            this.lubricationData.forEach((sistema, sistemaIndex) => {
                sistema.equipo.forEach((equipo, equiIndex) => {
                    equipo.componentes.forEach((componente, compIndex) => {
                        rows.push({
                            sistema: compIndex === 0 ? sistema.sistema : null,
                            rowspanSistema: compIndex === 0 ? sistema.rowspanSistema : 0,
                            equipo: compIndex === 0 ? equipo.nombre : null,
                            rowspanEquipo: compIndex === 0 ? equipo.rowspanEquipo : 0,
                            totalPuntos: compIndex === 0 ? equipo.totalPuntos : null,
                            rowspanTotalPuntos: compIndex === 0 ? equipo.rowspanTotalPuntos : null,
                            ...componente
                        });
                    });
                });
            });
            return rows;
        },
        getDateStyle(color) {
            return color == 'red' ? "color: red; font-weight: bold;" : "";
        },

        getRowClass(index) {
            let item = this.lubricationData[index];

            // Si cambia de sistema o equipo, alternamos el color
            if (item.sistema && (item.sistema !== this.lastSistema || item.equipo !== this.lastEquipo)) {
                this.currentColorIndex = 1 - this.currentColorIndex; // Alterna entre 0 y 1
                this.lastSistema = item.sistema;
                this.lastEquipo = item.equipo;
            }

            return this.rowColors[this.currentColorIndex];
        },

        formatDate(date) {
            if (!date) return ""; // Si la fecha es null o undefined, no mostrar nada

            // Convertir "yyyy-mm-dd" a "dd-mm-yyyy"
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },
        async generaEngraseTabla(item) {
            this.skill = 0;
            SwalService.loading('Cargando..', 'Por favor espere.');
            const parametros = {
                embarcacion: item.embarcacion,
                id: item.id,
                idEstado: item.idEstadoEngrase
            }
            const response = await apiService.get("/engrase/get-sistema-engrase", parametros);
            let datos = response.data.sistemasEngrase;
            let rows = [];

            datos.forEach((sistema, sistemaIndex) => {
                sistema.equipo.forEach((equipo, equiIndex) => {
                    equipo.componentes.forEach((componente, compIndex) => {
                        // Validaciones y correcciones
                        let numPuntos = componente.numPuntos ?? "";
                        let lubricanteFabricante = componente.lubricanteFabricante ?? "No especificado";
                        let lubricantePropuesto = componente.lubricantePropuesto ?? "No especificado";
                        let numBombeadas = componente.numBombeadas ?? "No especificado";
                        let frecuencia = componente.frecuencia ?? "No especificado";

                        // Corregir `data`
                        let data = componente.data.map(item => ({
                            id: item.id,
                            name: item.name.replace("null", "No especificado"),
                            children: item.children.map(child => ({
                                id: child.id,
                                name: child.name.replace("null", "No especificado")
                            }))
                        }));

                        rows.push({
                            sistema: (equiIndex === 0 && compIndex === 0) ? sistema.sistema : null,
                            rowspanSistema: (equiIndex === 0 && compIndex === 0) ? sistema.rowspanSistema : 0,
                            equipo: (compIndex === 0) ? equipo.nombre : null,
                            rowspanEquipo: (compIndex === 0) ? equipo.rowspanEquipo : 0,
                            totalPuntos: (compIndex === 0) ? equipo.totalPuntos : null,
                            rowspanTotalPuntos: (compIndex === 0) ? equipo.rowspanTotalPuntos : 0,
                            prioritario: equipo.prioritario,

                            ...componente
                        });

                    });
                });
            });

            this.paso = item.idEstadoEngrase;;
            this.lubricationData = rows;
            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
            this.data.id = item.estadoEngrase == 3 ? null : item.id;
            this.data.embarcacion = item.embarcacion;
            this.data.idResponsable = item.idResponsable;
            this.data.responsable = item.responsable;
            this.data.idEstado = this.paso;
            this.data.estado = item.estadoEngrase;
            this.data.fechaEngrase = item.fechaEngrase;
            this.fechaDesde = item.estadoEngrase == 3 ? this.fechaDesde = new Date().toISOString().substr(0, 10) : item.fechaEngrase;
            if (this.paso === 2) {
                this.clearSignature();
                this.limpiarImagenFirma();
            }

            this.dialogForm = true;

        },
        async generaEngrase(item) {
            this.skill = 0;
            SwalService.loading('Cargando..', 'Por favor espere.');
            const parametros = {
                embarcacion: item
            }
            const response = await apiService.get("/engrase/get-sistema-engrase", parametros);
            let datos = response.data.sistemasEngrase;
            let rows = [];

            datos.forEach((sistema, sistemaIndex) => {
                sistema.equipo.forEach((equipo, equiIndex) => {
                    equipo.componentes.forEach((componente, compIndex) => {
                        // Validaciones y correcciones
                        let numPuntos = componente.numPuntos ?? "";
                        let lubricanteFabricante = componente.lubricanteFabricante ?? "No especificado";
                        let lubricantePropuesto = componente.lubricantePropuesto ?? "No especificado";
                        let numBombeadas = componente.numBombeadas ?? "No especificado";
                        let frecuencia = componente.frecuencia ?? "No especificado";

                        // Corregir `data`
                        let data = componente.data.map(item => ({
                            id: item.id,
                            name: item.name.replace("null", "No especificado"),
                            children: item.children.map(child => ({
                                id: child.id,
                                name: child.name.replace("null", "No especificado")
                            }))
                        }));

                        rows.push({
                            sistema: (equiIndex === 0 && compIndex === 0) ? sistema.sistema : null,
                            rowspanSistema: (equiIndex === 0 && compIndex === 0) ? sistema.rowspanSistema : 0,
                            equipo: (compIndex === 0) ? equipo.nombre : null,
                            rowspanEquipo: (compIndex === 0) ? equipo.rowspanEquipo : 0,
                            totalPuntos: (compIndex === 0) ? equipo.totalPuntos : null,
                            rowspanTotalPuntos: (compIndex === 0) ? equipo.rowspanTotalPuntos : 0,
                            prioritario: equipo.prioritario,

                            ...componente
                        });

                    });
                });
            });

            this.paso = 1;
            this.lubricationData = rows;
            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
            this.data.id = null;
            this.data.embarcacion = item;
            this.data.idResponsable = this.idUsuario;
            this.data.responsable = this.responsable;
            this.data.idEstado = this.paso;
            this.data.estado = 'Genera Engrase'
            this.data.fechaEngrase = this.formattedDesde
            this.dialogForm = true;
            this.fechaDesde = new Date().toISOString().substr(0, 10);
        },
        onDialogOpened(isOpen) {
            if (isOpen && this.paso === 2) {
                this.$nextTick(() => {
                    this.initSignaturePad();
                });
            }
        },
        initSignaturePad() {
            this.$nextTick(() => {
                const canvas = this.$refs.canvas;
                const container = this.$refs.signatureContainer;

                if (canvas && container) {
                    // Ajustar tamaño del canvas al del contenedor
                    canvas.width = container.clientWidth;
                    canvas.height = container.clientHeight;

                    // Corregir el contexto de dibujo en algunos navegadores
                    const ctx = canvas.getContext("2d");
                    ctx.fillStyle = "white"; // Fondo blanco
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    // Inicializar SignaturePad
                    this.signaturePad = new SignaturePad(canvas, {
                        minWidth: 1,
                        maxWidth: 3,
                        penColor: "black",
                    });

                    console.log("SignaturePad inicializado correctamente.");
                } else {
                    console.error("No se encontró el canvas o el contenedor.");
                }
            });
        },
        saveSignature() {
            if (this.signaturePad && !this.signaturePad.isEmpty()) {
                this.signatureData = this.signaturePad.toDataURL();
                this.showCanvas = false; // Oculta el canvas después de guardar la firma
            } else {
                console.warn("No hay firma para guardar.");
            }
        },
        clearSignature() {
            if (this.signaturePad) {
                this.signaturePad.clear();
            }
        },
        limpiarImagenFirma() {
            this.signatureData = null; // Eliminar la imagen de la firma

            // Ocultar el canvas para forzar su re-renderizado
            this.showCanvas = false;

            // Esperar a que el DOM se actualice y volver a mostrar el canvas
            this.$nextTick(() => {
                this.showCanvas = true;
                this.$nextTick(() => {
                    this.initSignaturePad(); // Volver a inicializar el SignaturePad
                });
            });
        },
        async engraseRegistro() {
            if (this.skill < 100) {
                SwalService.alert("Debe completar todos los engrases antes de continuar.");
            } else {
                this.paso = 2;
                this.$nextTick(() => {
                    this.initSignaturePad();
                });
                this.data.idEstado = this.paso;
                this.data.fechaEngrase = this.fechaDesde;
                const data = {
                    dataEngrase: this.data,
                    dataCheckList: this.lubricationData
                }
                
                const registro = await apiService.post(`/engrase/guardar-engrase`, data);
                this.data.id = registro.data.engrase.id;
                const response = await apiService.get("/engrase/get-control-engrase");
                this.items = response.data.controles;
                const response2 = await apiService.get("/engrase/get-embarcacion-engrase");
                if (response2.data.embarcacionList.length > 0) {
                    this.embarcs = response2.data.embarcacionList;
                } else {
                    this.embarcs = [];
                }
            }
        },
        async enviarEngraseRegistro() {
            if (this.signatureData) {
                this.data.idEstado = 3;
                this.data.firmaResponsable = this.signatureData
                this.data.fechaEngrase = this.fechaDesde;
                this.data.fechaReporte = new Date().toISOString().substr(0, 10);
                this.dialogForm = false;
                SwalService.loading('Enviando..', 'Por favor espere.');
                const data = {
                    dataEngrase: this.data,
                    dataCheckList: this.lubricationData
                }
                await apiService.post(`/engrase/guardar-engrase`, data);
                const response = await apiService.get("/engrase/get-control-engrase");
                this.items = response.data.controles;

                const response2 = await apiService.get("/engrase/get-embarcacion-engrase");
                if (response2.data.embarcacionList.length > 0) {
                    this.embarcs = response2.data.embarcacionList;
                } else {
                    this.embarcs = [];
                }
                this.selectedEmb = null;
                setTimeout(async () => {
                    SwalService.close();
                    await new Promise(resolve => setTimeout(resolve, 100));
                    SwalService.success('Envio Completado', 'Se ha enviado correctamente el check list de engrase de BAMAR I al correo equipoejecucionflota@hayduk.com.pe');
                }, 3000);
            } else {
                SwalService.alert("Debe guardar la firma del responsable antes de enviar el reporte de engrase.");
            }
        },
        adjuntarEvidencia(item) {
            this.titleAdjuntos = item.nombre;
            this.dialogAdjuntos = true;
        },
        // Agregar nuevos archivos a la lista
        agregarAdjuntos() {
            if (this.nuevosAdjuntos) {
                this.adjuntos.push(...this.nuevosAdjuntos);
                this.nuevosAdjuntos = [];
            }
        },
        // Eliminar un archivo adjunto de la lista
        eliminarAdjunto(index) {
            this.adjuntos.splice(index, 1);
        },
        // Guardar los archivos adjuntos (puedes enviar a una API)
        guardarAdjuntos() {
            console.log("Archivos guardados:", this.adjuntos);
            this.dialogAdjuntos = false;
        },
        // Determinar si el archivo es una imagen
        esImagen(archivo) {
            return archivo && archivo.type.startsWith("image/");
        },
        async guardar() {
            SwalService.loading('Guardando..', 'Por favor espere.');
            this.data.idEstado = this.paso;
            this.data.fechaEngrase = this.fechaDesde;
            const data = {
                dataEngrase: this.data,
                dataCheckList: this.lubricationData
            }
            const registro = await apiService.post(`/engrase/guardar-engrase`, data);
        
            this.data.id  = registro.data.engrase.id;
            this.dialogForm = false;
            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
            const response = await apiService.get("/engrase/get-control-engrase");
            this.items = response.data.controles;
            const response2 = await apiService.get("/engrase/get-embarcacion-engrase");
            if (response2.data.embarcacionList.length > 0) {
                this.embarcs = response2.data.embarcacionList;
            } else {
                this.embarcs = [];
            }
            this.selectedEmb = null;
            SwalService.success('Éxito', 'Se guardado correctamente el reporte de engrase de la embarcación ' + this.data.embarcacion);
        },
        closeForm() {
            this.dialogForm = false;
        }

    }
};
</script>

<style scoped>
/* Estilos mejorados */
.v-data-table {
    border-radius: 10px;
    overflow: hidden;
    font-size: 12px !important;
}

.v-data-table>>>thead th {
    font-size: 13px !important;
    font-weight: bold;
    text-align: center !important;
    color: white !important;
    background-color: #05435B;
}


.v-data-table>>>tbody td {
    font-size: 12px !important;
}

.v-data-table>>>thead th.sortable .v-data-table-header__icon {
    color: white !important;
    font-weight: 700;
}

.switch-container {
    display: flex;
    justify-content: center;
    /* Centrar horizontalmente */
    align-items: center;
    /* Centrar verticalmente */
    padding: 0;
    margin: 0;
}


td {
    text-align: center !important;
    border-bottom: 1px solid #ddd;
    font-size: 14px !important;
}

.table-container {
    display: block;
}

.mobile-table {
    display: none;
}

/* Color para los grupos pares */
.zebra-even {
    background-color: #f2f2f2 !important;
}

/* Color para los grupos impares */
.zebra-odd {
    background-color: #ffffff !important;
}

.v-input--selection-controls__input+.v-label {
    font-size: 12px !important;
}

::v-deep(.v-treeview-node__label) {
    text-align: left !important;
}


.v-treeview-node__children {
    text-align: left;
}

::v-deep(.v-treeview-node__root) {
    min-height: 25px;
}



@media (max-width: 768px) {
    .desktop-table {
        display: none;
    }

    .mobile-table {
        display: block;
    }

    .scrollable-table {
        overflow-x: auto;
        white-space: nowrap;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th,
    td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .sticky-right {
        position: sticky;
        right: 0;
        background: white;
        z-index: 2;
    }
}
</style>